import React from 'react';
import { Box, Tooltip } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { useMetaTooltipProps } from './metaTooltipBoundary';

/**
 * Qué suma «contactos» (`contacts` de la API = `wa_conversations` + `leads`):
 * conversaciones de WhatsApp iniciadas + formularios de Meta completados.
 */
export const META_CONTACTS_HELP = 'Contactos = conversaciones de WhatsApp iniciadas + formularios completados.';

/**
 * ⓘ con el Tooltip de MUI (nunca `title` nativo: quedaba flotando sobre el mapa). El título va
 * como nodo para que MUI no le ponga `title` al hijo cerrado.
 */
export default function MetaContactsHelp({
  testId = 'meta-contacts-help', note = null, sx, ariaLabel = 'Qué cuenta como contacto',
}) {
  const boundaryProps = useMetaTooltipProps();
  // `note` (línea corta de la ficha): el desglose arriba y la definición abajo.
  const title = note ? <span>{note}<br />{META_CONTACTS_HELP}</span> : <span>{META_CONTACTS_HELP}</span>;
  return (
    <Tooltip title={title} placement="top" arrow describeChild {...boundaryProps}>
      <Box
        component="span"
        tabIndex={0}
        role="img"
        aria-label={ariaLabel}
        data-testid={testId}
        sx={{ display: 'inline-flex', alignItems: 'center', color: '#ABABAB', cursor: 'help', borderRadius: '50%', '&:focus-visible': { outline: '2px solid', outlineOffset: 1 }, ...sx }}
      >
        <InfoOutlinedIcon sx={{ fontSize: 14 }} aria-hidden />
      </Box>
    </Tooltip>
  );
}
